import { FeedbackPriority, FeedbackType } from '../api';

export const TYPE_LABELS: Record<FeedbackType, string> = {
  new_idea: 'New Idea',
  bug: 'Bug/Issue',
  enhancement: 'Enhancement',
};

export const TYPE_HELP: Record<FeedbackType, string> = {
  new_idea: 'Something the portal does not do yet.',
  bug: 'Something is broken or behaves unexpectedly.',
  enhancement: 'Something that works but could be better.',
};

export const PRIORITY_LABELS: Record<FeedbackPriority, string> = {
  nice_to_have: 'Nice to have',
  important: 'Important',
  critical: 'Critical',
};

export const PRIORITY_HELP: Record<FeedbackPriority, string> = {
  nice_to_have: 'No rush; whenever there is time.',
  important: 'Slows you down or affects several people.',
  critical: 'Blocks you or breaks something in use today.',
};
